/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileCorpTransactionsQueryResponse, GetUsersProfileCorpTransactionsQueryParams, GetUsersProfileCorpTransactions400 } from "../entities/GetUsersProfileCorpTransactions";

function getGetUsersProfileCorpTransactionsUrl() {
  const res = { method: 'GET', url: `/users/profile/corp-transactions` as const }  
  return res
}

/**
 * @description Получение истории транзакций corp
 * @summary Получение истории транзакций corp
 * {@link /users/profile/corp-transactions}
 */
export async function getUsersProfileCorpTransactions(params?: GetUsersProfileCorpTransactionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetUsersProfileCorpTransactionsQueryResponse, ResponseErrorConfig<GetUsersProfileCorpTransactions400>, unknown>({ method : "GET", url : getGetUsersProfileCorpTransactionsUrl().url.toString(), params, ... requestConfig })  
  return res.data
}